<template>
  <BaseDialog isOpen>
    <template v-slot:title>
      <div>
        Add Application Question
      </div>
    </template>
    <template v-slot:body>
      <ValidationObserver ref="newApplicationQuestionForm">
        <ValidationProvider v-slot="{ errors }" rules="required">
          <Select
            :loading="isFetchingOrganisationApplicationQuestionTemplates"
            :disabled="isFetchingOrganisationApplicationQuestionTemplates"
            v-model="selectedQuestionTemplate"
            :label="label"
            :items="organisationApplicationQuestionTemplates"
            item-text="question"
            item-value="id"
            returnObject
            :error-messages="showValidationErrors ? errors : ''"
            autocomplete
          />
        </ValidationProvider>
      </ValidationObserver>
    </template>
    <template v-slot:actions>
      <div>
        <PrimaryButton @click.native="close" text>
          Cancel
        </PrimaryButton>
        <PrimaryButton @click.native="handleSubmit">
          Add
        </PrimaryButton>
      </div>
    </template>
  </BaseDialog>
</template>

<script>
import BaseDialog from "@/components/common/BaseDialog";
import PrimaryButton from "@/components/common/Button/PrimaryButton";
import { createNamespacedHelpers } from "vuex";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import { FETCH_APPLICATION_QUESTION_TEMPLATES } from "@/store/modules/organisations/organisation-application-question-templates/actions";
import { ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE } from "@/store/modules/organisations/organisation-application-question-templates";
import Select from "@/components/common/Select";
import { lowerCase } from "lodash";

const { mapActions, mapState } = createNamespacedHelpers(
  ORGANISATION_APPLICATION_QUESTION_TEMPLATES_NAMESPACE
);

export default {
  name: "ResendInvitationDialog",
  components: {
    PrimaryButton,
    BaseDialog,
    ValidationObserver,
    ValidationProvider,
    Select
  },
  props: {
    title: { type: String, required: true }
  },
  created() {
    this.fetchApplicationQuestionTemplates({
      filter: { required: lowerCase(this.label) === "screening" ? 1 : 0 }
    });
  },
  data() {
    return {
      showValidationErrors: false,
      selectedQuestionTemplate: null
    };
  },
  computed: {
    ...mapState([
      "organisationApplicationQuestionTemplates",
      "isFetchingOrganisationApplicationQuestionTemplates"
    ]),
    currentOfferId() {
      return this.$route.params.id;
    },
    label() {
      return this.title.substring(0, this.title.indexOf(" "));
    }
  },
  methods: {
    ...mapActions({
      fetchApplicationQuestionTemplates: FETCH_APPLICATION_QUESTION_TEMPLATES
    }),
    async handleSubmit() {
      this.showValidationErrors = true;
      const isValid = await this.$refs.newApplicationQuestionForm.validate();
      if (isValid) {
        this.$emit("onAdd", this.selectedQuestionTemplate);
      }
    },
    close() {
      this.$emit("close");
    }
  }
};
</script>

<style lang="scss"></style>
